module.exports = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY_EMA_SANDBOX,
  tenant: 'ema-app-sandbox',
  messageLimit: 20,
  promptSuggestions: {
    group1Header: 'For Prospective Partners:',
    group2Header: 'For Users:',
  },
  messageFlagEnabled: true,
  pageTitle: 'Ema - Website',
};
